export const BASE_URL = "https://api.appforclass.com/api/v1"